import { all, call, select } from 'redux-saga/effects';

import { deleteCustomerRole, postCustomer } from 'data-providers/insuranceAnketa';
import * as InsuranceAnketaConstants from 'store/insuranceAnketa/constants';
import * as InsuranceAnketaSelectors from 'store/insuranceAnketa/selectors';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import { aggregateCustomerIDsByRole } from '../helpers';

const DEFAULT_AFTER_CALLBACK = ({ applicationId, customerId, feature, response, role }) => {
  return { applicationId, customerId, feature, response, role };
};

export function* customerRoleManaging({
  afterAdd = DEFAULT_AFTER_CALLBACK,
  afterDelete = DEFAULT_AFTER_CALLBACK,
  customerId: customerIdParam,
  feature,
  role,
}) {
  const [applicationId, roles] = yield all([
    select(InsuranceCalculationSelectors.selectApplicationId),
    select(InsuranceAnketaSelectors.selectField(InsuranceAnketaConstants.FIELDS.CUSTOMER_ROLES)),
  ]);

  if (!applicationId || !customerIdParam) {
    return;
  }

  const customerId = String(customerIdParam);
  const { [role]: roleMap } = aggregateCustomerIDsByRole({ roles });
  const { id: roleId } = roleMap.get(customerId) ?? {};
  const hasRole = typeof roleId !== 'undefined';

  const baseAfterCallbackParams = { applicationId, customerId: customerIdParam, feature, role };

  if (!feature && hasRole) {
    const response = yield call(deleteCustomerRole, {
      applicationId,
      personRoleId: roleId,
    });

    afterDelete({ ...baseAfterCallbackParams, response });
  } else if (feature && !hasRole) {
    const response = yield call(postCustomer, {
      applicationId,
      payload: { customerId, isActive: true, roleSysName: role },
    });

    afterAdd({ ...baseAfterCallbackParams, response });
  }
}
